// SearchBar.jsx
import { useState, useRef, useEffect } from "react"
import {
  Box,
  TextField,
  Button,
  Paper,
  List,
  ListItemButton,
} from "@mui/material"

export function SupplieSearchBar({ supplies = [], onSearch }) {
  const [searchTerm, setSearchTerm] = useState("")
  const [suggestions, setSuggestions] = useState([])
  const suggestionsRef = useRef(null)

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        suggestionsRef.current &&
        !suggestionsRef.current.contains(event.target)
      ) {
        setSuggestions([])
      }
    }
    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [])

  const handleInputChange = (e) => {
    const value = e.target.value
    setSearchTerm(value)

    if (value.trim() === "") {
      setSuggestions([])
      onSearch("")
      return
    }

    const filtered = supplies
      ?.filter((s) =>
        s.name.toLowerCase().includes(value.toLowerCase())
      )
      .slice(0, 5)
    setSuggestions(filtered)
    onSearch(value)
  }

  const handleSuggestionClick = (name) => {
    setSearchTerm(name)
    setSuggestions([])
    onSearch(name)
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    onSearch(searchTerm)
    setSuggestions([])
  }

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      sx={{ position: "relative", width: "100%", mb: 2 }}
    >
      <Box sx={{ display: "flex" }}>
        <TextField
          value={searchTerm}
          onChange={handleInputChange}
          placeholder="Search supplies..."
          variant="outlined"
          size="small"
          fullWidth
        />
        <Button
          type="submit"
          variant="contained"
          sx={{ ml: 1 }}
        >
          Search
        </Button>
      </Box>

      {suggestions.length > 0 && (
        <Paper
          ref={suggestionsRef}
          sx={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            zIndex: 10,
            mt: 0.5,
          }}
        >
          <List dense>
            {suggestions.map((s) => (
              <ListItemButton
                key={s.id}
                onClick={() => handleSuggestionClick(s.name)}
              >
                {s.name}
              </ListItemButton>
            ))}
          </List>
        </Paper>
      )}
    </Box>
  )
}
